import {
  GET_INSTALLMENT_PLANS_ELIGIBILITY,
  GET_INSTALLMENT_PLANS_ELIGIBILITY_SUCCESS,
  GET_INSTALLMENT_PLANS_ELIGIBILITY_FAILURE,
  REVIEW_INSTALLMENT_PLAN,
  SUBMIT_INSTALLMENT_PLAN_PAYMENT,
  SUBMIT_INSTALLMENT_PLAN_PAYMENT_SUCCESS,
  SUBMIT_INSTALLMENT_PLAN_PAYMENT_FAILURE,
  SUBMIT_INSTALLMENT_PLAN_ENROLLMENT,
  SUBMIT_INSTALLMENT_PLAN_ENROLLMENT_FAILURE,
  SUBMIT_INSTALLMENT_PLAN_CONFIRMATION,
} from '../actions/installmentPlans';

/**
 * @type {import('../types/state/installmentPlansState').InstallmentPlansState}
 */
const INITIAL_STATE = {
  plan: null,
  loading: true,
  error: null,
  review: null,
  confirm: null,
  submitting: false,
};

const reducers = {
  [GET_INSTALLMENT_PLANS_ELIGIBILITY]: state => ({
    ...state,
    loading: true,
    error: null,
  }),
  [GET_INSTALLMENT_PLANS_ELIGIBILITY_SUCCESS]: (state, { payload }) => ({
    ...state,
    plan: payload,
    loading: false,
    error: null,
  }),
  [GET_INSTALLMENT_PLANS_ELIGIBILITY_FAILURE]: (state, { payload }) => ({
    ...state,
    plan: null,
    loading: false,
    error: payload,
  }),
  [REVIEW_INSTALLMENT_PLAN]: (state, { payload }) => ({
    ...INITIAL_STATE,
    plan: state.plan,
    loading: state.loading,
    review: payload,
  }),
  [SUBMIT_INSTALLMENT_PLAN_PAYMENT]: state => ({
    ...state,
    submitting: true,
    error: null,
  }),
  [SUBMIT_INSTALLMENT_PLAN_PAYMENT_SUCCESS]: state => ({
    ...state,
    submitting: true,
    error: null,
  }),
  [SUBMIT_INSTALLMENT_PLAN_PAYMENT_FAILURE]: (state, { payload }) => ({
    ...state,
    submitting: false,
    error: payload,
  }),
  [SUBMIT_INSTALLMENT_PLAN_ENROLLMENT]: state => ({
    ...state,
    submitting: true,
    error: null,
  }),
  [SUBMIT_INSTALLMENT_PLAN_ENROLLMENT_FAILURE]: (state, { payload }) => ({
    ...state,
    submitting: false,
    error: payload,
  }),
  [SUBMIT_INSTALLMENT_PLAN_CONFIRMATION]: (state, { payload }) => ({
    ...state,
    submitting: false,
    review: null,
    confirm: { ...state.review, enrollmentResponse: payload },
    error: null,
  }),
};

export default function installmentPlansReducer(state = INITIAL_STATE, action) {
  return (
    reducers[action.type]
      ? reducers[action.type](state, action)
      : state
  );
}
